import { tns } from 'tiny-slider'

let slider = '.news-block .js-slider'

let blockLoaded = false
let blockLoadedInterval = setInterval(function() {
  if (document.querySelector(slider)) {
    tns({
      container: slider,
      prevButton: '.news-block .slider-controls .prev',
      nextButton: '.news-block .slider-controls .next',
      nav: false,
      // autoplay: true,
      autoplayButtonOutput: false,
      lazyload: true,
      loop: false,
      mouseDrag: true,
      responsive: {
        0: {
          items: 1,
        },
        1280: {
          items: 1.25,
          gutter: 150,
        },
      },
    })

    blockLoaded = true
  }

  if (blockLoaded) {
    clearInterval(blockLoadedInterval)
  }
}, 500)



// WEBPACK FOOTER //
// ./scripts/block-news.js